import { h } from 'preact';
import { SelectEntry } from '@epx/flow';

const getComplexTypes = (i18n) => [
  { value: '', label: i18n['opt.none'] || '-- None --' },
  { value: 'SignTogether', label: i18n['opt.SignTogether'] || 'Sign Together' },
  { value: 'SignForward', label: i18n['opt.SignForward'] || 'Sign Forward' },
  { value: 'SignInOrder', label: i18n['opt.SignInOrder'] || 'Sign In Order' },
];

// Values must match sfd XML (PascalCase — sfd stores the option "name" in XML)
const getMergeTypes = (i18n) => [
  { value: '', label: i18n['opt.none'] || '-- None --' },
  { value: 'Sequence', label: i18n['opt.Sequence'] || 'Sequence' },
  { value: 'Parallel', label: i18n['opt.Parallel'] || 'Parallel' },
  { value: 'Any', label: i18n['opt.Any'] || 'Any' },
];

const getCompareTypes = (i18n) => [
  { value: '', label: i18n['opt.none'] || '-- None --' },
  { value: 'Count', label: i18n['opt.Count'] || 'Count' },
  { value: 'Percentage', label: i18n['opt.Percentage'] || 'Percentage' },
];

const getCompleteOrders = (i18n) => [
  { value: '', label: i18n['opt.none'] || '-- None --' },
  { value: 'Sequential', label: i18n['opt.Sequential'] || 'Sequential' },
  { value: 'Parallel', label: i18n['opt.Parallel'] || 'Parallel' },
];

const TASK_TYPES = ['epx:UserTask', 'epx:ManualTask'];

export class SfdMultiSignPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return TASK_TYPES.includes(elementType);
  }

  getGroups(element) {
    const lf = this._lf;
    const i18n = this._i18n;
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'multiSign',
        label: i18n.multiSign || 'Multi-Sign',
        isEdited: () => !!(props.complexType || props.mergeType || props.compareType || props.completeOrder),
        entries: [
          {
            id: 'complexType',
            component: () => (
              <SelectEntry
                id="sfd-complexType"
                label={i18n.complexType || 'Complex Type'}
                value={props.complexType || ''}
                options={getComplexTypes(i18n)}
                onChange={(val) => update('complexType', val)}
              />
            ),
          },
          {
            id: 'mergeType',
            component: () => (
              <SelectEntry
                id="sfd-mergeType"
                label={i18n.mergeType || 'Merge Type'}
                value={props.mergeType || ''}
                options={getMergeTypes(i18n)}
                onChange={(val) => update('mergeType', val)}
              />
            ),
          },
          {
            id: 'compareType',
            component: () => (
              <SelectEntry
                id="sfd-compareType"
                label={i18n.compareType || 'Compare Type'}
                value={props.compareType || ''}
                options={getCompareTypes(i18n)}
                onChange={(val) => update('compareType', val)}
              />
            ),
          },
          {
            id: 'completeOrder',
            component: () => (
              <SelectEntry
                id="sfd-completeOrder"
                label={i18n.completeOrder || 'Complete Order'}
                value={props.completeOrder || ''}
                options={getCompleteOrders(i18n)}
                onChange={(val) => update('completeOrder', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
